import React, { useState, useEffect } from 'react';
// import ReactDOM from 'react-dom';
// import { connect } from 'react-redux';
import Tools from '../../tools';
import { Button, Container, Modal, Row, Col, Form, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import API from '../../api';
import { Cookies, withCookies } from 'react-cookie';
import Enums from '../../enums'
import img1 from "../../images/demo/img1.png"
import img2 from "../../images/demo/img2.png"
import img3 from "../../images/demo/img3.png"

// import { useMappedState, useDispatch } from 'redux-react-hook';

export default withCookies(function ChargeCalculatorPartDemoApp(props) {
    const [qCnts, setQCnts] = useState(5);
    const [quota, setQuota] = useState(100);
    const [gender, setGender] = useState(0);
    const [age, setAge] = useState(0);
    const [area, setArea] = useState(0);
    const [discount, setDiscount] = useState("");

    function CustomButton(props) {
        let infoStyle = {
            backgroundColor: "transparent",
            barderColor: "lightgray"
        };

        if (props.variant == "info") {
            return (
                <Button ref={(node) => {
                    if (node) {
                        node.style.setProperty("color", "#6d6c6d", "important");
                    }
                }}
                    size={props.size}
                    variant={props.variant}
                    onClick={props.onClick}
                    style={Object.assign({ backgroundColor: "transparent", barderColor: "lightgray", marginLeft: "10px" }, props.variant == "info" ? infoStyle : {}, props.style)}>{props.children}</Button>
            )
        }
        return (
            <Button variant={props.variant}
                size={props.size}
                onClick={props.onClick}
                style={Object.assign({ marginLeft: "10px" }, props.style)}>{props.children}</Button>
        )
    }

    function onNumChange(e, callback) {
        e.stopPropagation();
        e.preventDefault();
        let tmp = parseInt(e.target.value);
        if (false == isNaN(tmp)) {
            callback(tmp);
        }
    }

    function onSubmit(e) {
        e.stopPropagation();
        e.preventDefault();
        // if (qCnts < 5) {
        //     alert("題數最少為5");
        //     setQCnts(5);
        // }

        let tmp = {
            max_people: quota,
            gender: gender,
            age: age,
            region: area,
            discount_code: discount
        };
        if (props.isShowQCunts) {
            tmp.question_number = qCnts;
        }
        props.onSubmit(tmp)
    }

    function onSaveAndBack(e) {
        e.stopPropagation();
        e.preventDefault();
        // if (qCnts < 5) {
        //     alert("題數最少為5");
        //     setQCnts(5);
        // }

        let tmp = {
            max_people: quota,
            gender: gender,
            age: age,
            region: area,
            discount_code: discount
        };
        if (props.isShowQCunts) {
            tmp.question_number = qCnts;
        }
        props.onSaveAndBack(tmp)
    }

    function onDeposit(e) {
        e.stopPropagation();
        e.preventDefault();
        console.log("onDeposit");

        props.onDeposit();
    }

    function onQCntsChange(val) {
        setQCnts(val);
    }
    function onQCntsBlur() {
        let tmp = parseInt(qCnts);
        if (isNaN(tmp)) {
            alert("請輸入數字");
            setQCnts(5);
        } else if (tmp < 5) {
            alert("題數最小為5題");
            setQCnts(5);
        } else {
            setQCnts(tmp);
        }
    }

    function render() {
        let tmp = Enums.E_QUOTA;
        let checkDom = [];
        tmp.forEach((val, idx) => {
            checkDom.push(
                <CustomButton
                    style={{ width: "56px" }}
                    variant={val == quota ? "primary" : "info"}
                    key={`quota-${idx}`}
                    onClick={() => { setQuota(val) }}>{val}</CustomButton>
            );
        });

        let genderDom = [];
        for (let key in Enums.E_GENDER_TEXT) {
            genderDom.push(
                // <Col sm={0 == key ? "auto" : 2} id={`gender-${key}`}>
                //     <Form.Check type="radio" label={Enums.E_GENDER_TEXT[key]} value={key} name="gender" checked={key == gender} onChange={() => { setGender(key) }} />
                // </Col>
                <CustomButton
                    style={{ width: "93px" }}
                    variant={key == gender ? "primary" : "info"}
                    key={`gender-${key}`}
                    onClick={() => { setGender(key) }}>{Enums.E_GENDER_TEXT[key]}</CustomButton>
            );
        }

        let ageDom = [];
        for (let key in Enums.E_AGE_TEXT) {
            ageDom.push(
                // <Col sm={"auto"} id={`age-${key}`}>
                //     <Form.Check type="radio" label={Enums.E_AGE_TEXT[key]} value={key} name="age" checked={key == age} onChange={() => { setAge(key) }} />
                // </Col>
                <CustomButton
                    size="sm"
                    // style={(0 == key ? { width: "93px" } : {})}
                    variant={key == age ? "primary" : "info"}
                    key={`age-${key}`}
                    onClick={() => { setAge(key) }}>{Enums.E_AGE_TEXT[key]}</CustomButton>
            );
        }

        let areaDom = [];
        for (let key in Enums.E_AREA_TEXT) {
            areaDom.push(
                // <Form.Group as={Row} className="" controlId="formPlaintextArea" id={`area-${key}`}>
                //     <Form.Label column sm="1"></Form.Label>
                //     <Col sm={10}>
                //         <Form.Check inline type="radio" label={Enums.E_AREA_TEXT[key]} value={key} name="area" checked={key == area} onChange={() => { setArea(key) }} />
                //         <small>{Enums.E_AREA_PS_TEXT[key]}</small>
                //     </Col>
                // </Form.Group>
                <CustomButton
                    size="sm"
                    variant={key == area ? "primary" : "info"}
                    key={`area-${key}`}
                    onClick={() => { setArea(key) }}>{Enums.E_AREA_TEXT_SHORT[key]}</CustomButton>
            );
        }

        // estimate_days: 2
        // formula: "(5 * 200 * 1.50 * 1.10 * 1.50 = 2475)"
        // formula_text: "(題目數 5 * 樣本數 200 * 性別控樣係數 1.50 * 年齡控樣係數 1.10 * 地區控樣係數 1.50 = 2475)"
        // platform_point: 2475
        // price: 14850

        function CustomLabel(props) {
            return (
                <label style={{ borderBottom: "1px solid black", minWidth: "120px", marginBottom: "-5px" }}>{props.children}</label>
            )
        }

        let resultDom = (
            // props.isEstimate ? (
            <div className='text-center'>
                <h4 className='mb-4'><strong onClick={onSubmit} style={{
                    backgroundImage: `url(${img3})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    padding: "5px",
                    cursor: "pointer"
                }}>開始計算</strong></h4>
                <div style={{
                    border: "3px dashed pink",
                    marginLeft: "-15px",
                    marginRight: "-15px",
                    padding: "15px",
                    borderRadius: "17px"
                }}>
                    <Row style={{ marginLeft: "0px" }}><img src={img1} style={{ width: "25px", height: "25px", marginRight: "2px" }} />試算結果：</Row>
                    <Row style={{ marginLeft: "0px", textAlign: "center", display: "block", marginBottom: "" }}>
                        約為<CustomLabel>{props.result ? props.result.platform_point : ""}</CustomLabel>
                        點，單筆現金支付為<CustomLabel>{props.result ? props.result.price : ""}</CustomLabel>元
                    </Row>
                </div>
            </div>
        );

        let item_deco = (<img src={img2}
            style={{
                maxWidth: "18px",
                marginTop: "-3px",
                marginRight: "10px"
            }} />
        );

        let formRowStyle = {
            borderBottom: "1px solid lightgray",
            paddingBottom: "12px"
        };

        return (
            <Form>
                {props.isShowQCunts ? (
                    <Form.Group as={Row} className="mb-3" style={formRowStyle} controlId="formPlaintextQcnts">
                        <Form.Label column xs="12" md="4">
                            {item_deco}調查題數
                        </Form.Label>
                        <Col xs="12" md="8">
                            <Form.Control type="text" value={qCnts} onChange={(e) => { onQCntsChange(e.target.value) }} onBlur={onQCntsBlur} />
                        </Col>
                    </Form.Group>
                ) : null}

                <Form.Group as={Row} className="mb-3" style={formRowStyle} controlId="formPlaintextQuota">
                    <Form.Label column xs="12" md="4">
                        {item_deco}調查份數
                    </Form.Label>
                    {checkDom}
                </Form.Group>

                <Form.Group as={Row} className="mb-3" style={formRowStyle} controlId="formPlaintextGender">
                    <Form.Label column xs="12" md="4">
                        {item_deco}性別設定
                    </Form.Label>
                    {genderDom}
                </Form.Group>

                <Form.Group as={Row} className="mb-3" style={formRowStyle} controlId="formPlaintextAge">
                    <Form.Label column xs="12" md="4">
                        {item_deco}年齡設定
                    </Form.Label>
                    {ageDom}
                </Form.Group>

                <Form.Group as={Row} className="mb-3" style={formRowStyle} controlId="formPlaintextArea">
                    <Form.Label column xs="12" md="4">
                        {item_deco}地區設定
                    </Form.Label>
                    {areaDom}
                </Form.Group>

                <Form.Group as={Row} className="mt-4 mb-4" controlId="formPlaintextAge">
                    <Form.Label column xs="12" md="4">
                        {item_deco}輸入優惠代碼
                    </Form.Label>
                    <Col xs="12" md="8">
                        <Form.Control autoComplete="discount" name="hidden" type="text" value={discount} onChange={(e) => { setDiscount(e.target.value) }} placeholder="" />
                    </Col>
                </Form.Group>

                {resultDom}
            </Form >
        );
    }
    return render();
})